import { Box, BoxProps } from '@material-ui/core';
import React, { ComponentProps } from 'react';

export const Duo = ({
  first,
  second,
  alignItems,
  gridColumnGap,
  ...boxProps
}: {
  first: React.ReactNode;
  second: React.ReactNode;
  alignItems?: BoxProps['alignItems'];
  gridColumnGap?: number;
} & Omit<ComponentProps<typeof Box>, 'children'>) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems={alignItems || 'flex-start'}
      gridColumnGap={gridColumnGap}
      {...boxProps}
    >
      <Box flexGrow={0} display="flex">
        {first}
      </Box>
      <Box flexGrow={1} display="flex">
        {second}
      </Box>
    </Box>
  );
};
